"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMintAndVault = exports.createMintInstructions = void 0;
var tslib_1 = require("tslib");
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
function createMintInstructions(provider, authority, mint, decimals) {
    if (decimals === void 0) { decimals = 6; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var instructions, _a, _b;
        var _c;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = web3_js_1.SystemProgram).createAccount;
                    _c = {
                        fromPubkey: provider.wallet.publicKey,
                        newAccountPubkey: mint,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                        space: spl_token_1.MintLayout.span
                    };
                    return [4 /*yield*/, provider.connection.getMinimumBalanceForRentExemption(
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        spl_token_1.MintLayout.span)];
                case 1:
                    instructions = [
                        _b.apply(_a, [(_c.lamports = _d.sent(),
                                _c.programId = spl_token_1.TOKEN_PROGRAM_ID,
                                _c)]),
                        spl_token_1.Token.createInitMintInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint, decimals, authority, null)
                    ];
                    return [2 /*return*/, instructions];
            }
        });
    });
}
exports.createMintInstructions = createMintInstructions;
function createMintAndVault(provider, amount, owner, decimals) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var mint, vault, tx, _a, _b, _c, _d, _e, _f, _g;
        var _h;
        return tslib_1.__generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (owner === undefined) {
                        owner = provider.wallet.publicKey;
                    }
                    mint = web3_js_1.Keypair.generate();
                    vault = web3_js_1.Keypair.generate();
                    tx = new web3_js_1.Transaction();
                    _b = (_a = tx.add).apply;
                    _c = [tx];
                    _d = [[]];
                    return [4 /*yield*/, createMintInstructions(provider, provider.wallet.publicKey, mint.publicKey, decimals)];
                case 1:
                    _e = [tslib_1.__spreadArray.apply(void 0, _d.concat([(_j.sent()), false]))];
                    _g = (_f = web3_js_1.SystemProgram).createAccount;
                    _h = {
                        fromPubkey: provider.wallet.publicKey,
                        newAccountPubkey: vault.publicKey,
                        space: 165
                    };
                    return [4 /*yield*/, provider.connection.getMinimumBalanceForRentExemption(165)];
                case 2:
                    _b.apply(_a, _c.concat([tslib_1.__spreadArray.apply(void 0, _e.concat([[_g.apply(_f, [(_h.lamports = _j.sent(),
                                        _h.programId = spl_token_1.TOKEN_PROGRAM_ID,
                                        _h)]),
                                spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint.publicKey, vault.publicKey, owner),
                                spl_token_1.Token.createMintToInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint.publicKey, vault.publicKey, provider.wallet.publicKey, [], amount)], false]))]));
                    return [4 /*yield*/, provider.sendAndConfirm(tx, [mint, vault])];
                case 3:
                    _j.sent();
                    return [2 /*return*/, [mint.publicKey, vault.publicKey]];
            }
        });
    });
}
exports.createMintAndVault = createMintAndVault;
